import { useEffect, useState } from "react";
import ContentStepper from "../../common/components/ContentStepper.tsx/ContentStepper";
import ModalContainer from "../../common/components/ModalContainer/ModalContainer";
import { fakeFormQuestion, getCopyOf, getError, initialFormQuestion, openNotification, tryCatch } from "../../common/constants/Utilities";
import { OptionTypeAnswer, PreguntaTipo, VisualizacionFormulario } from "../../common/enums/AllEnums";
import { getQuestionsByFormID } from "../../services/form";

// Internal Imports
import { Mode } from "../../common/types/AllTypes";
import { useAuth } from "../../contexts/auth";
import { useForm } from "../../contexts/form";
import { IForm, IFormQuestion } from "../../interfaces/IForm";
import { Step } from "../../interfaces/IStep";
import { InsertForm, UpdateForm } from "../../services/form";
import StepFour from "./FormSteps/StepFour";
import StepOne from "./FormSteps/StepOne";
import StepThree from "./FormSteps/StepThree";
import StepTwo from "./FormSteps/StepTwo";
import { IDepartment } from "../../interfaces/IDepartment";

interface Props {
    mode: Mode;
    setMode: React.Dispatch<React.SetStateAction<Mode>>;
    setAddUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
    listDepartment: IDepartment[];
    loadingDeparment: boolean;
    setDataList: (list: IForm[]) => void;
    dataList: IForm[]
}

const AddUpdateFormulario = ({ mode, setMode, setAddUpdateModal, setDataList, dataList, listDepartment, loadingDeparment }: Props) => {

    // States
    const { setFormQuestion, statusFormQuestion, formQuestion, loadingSubmit, setLoadingSubmit } = useForm();
    const [canGoNext, setCanGoNex] = useState<boolean>(false);
    const [canGoBack, setCanGoBack] = useState<boolean>(true);
    const { userInformation } = useAuth();

    // Const
    let ConstSteps = [
        {
            title: 'Información General',
            content: <StepOne mode={mode} setCanGoNext={setCanGoNex} />,
        },
        {
            title: 'Grupo de preguntas',
            content: <StepTwo mode={mode} setCanGoNext={setCanGoNex} setCanGoBack={setCanGoBack} />,
        },
        {
            title: 'Preguntas',
            content: <StepThree mode={mode} setCanGoNext={setCanGoNex} />,
        },
        {
            title: 'Formulario Detalle',
            content: <StepFour mode={mode} setCanGoNext={setCanGoNex} setCanGoBack={setCanGoBack} />,
        },
    ];

    const reviewQuestionFormBeforeSending = (form: IForm): IForm => {
        const formClone: IForm = getCopyOf(form);

        // Set UserModificoID
        formClone.usuarioModificoGUID = userInformation!.usuarioGUID!;

        formClone.pregunta?.forEach((element, index:number) =>  {

            // Set null to empty properties
            if (!element.valorMaximo) {
                element.valorMaximo = null;
            }

            if (!element.valorMinimo) {
                element.valorMinimo = null;
            }

            if (!element.query) {
                element.query = null;
            }

            if (!element.atributoNombre1) {
                element.atributoNombre1 = null;
            }
            if (!element.atributoValor1) {
                element.atributoValor1 = null;
            }

            if (!element.atributoNombre2) {
                element.atributoNombre2 = null;
            }
            if (!element.atributoValor2) {
                element.atributoValor2 = null;
            }

            if (!element.atributoNombre3) {
                element.atributoNombre3 = null;
            }
            if (!element.atributoValor3) {
                element.atributoValor3 = null;
            }

            // Reset order
            if (formClone?.esFormularioSecuencial) {
                element.orden = index + 1;
            }

            // Set OptionTypeAnswer
            if (element.preguntaTipoNombre === PreguntaTipo.Seleccion || element.preguntaTipoNombre === PreguntaTipo.SeleccionMultiple) {
                if (!!element.query) {
                    element.respuestaOpcionTipo = OptionTypeAnswer.Query;
                } else {
                    element.respuestaOpcionTipo = OptionTypeAnswer.Manual;
                }
            } else {
                element.respuestaOpcionTipo = OptionTypeAnswer.NA;
            }
        })

        if (formClone.visualizacionTipoNombre !== VisualizacionFormulario.ListadoDetalle && formClone.visualizacionTipoNombre !== VisualizacionFormulario.Mapa) {
            formClone.formularioDetalle = [];
        } else {
            formClone.formularioDetalle?.forEach(element => {
                if (!element.columnaValor) {
                    element.columnaValor = null;
                }
            });
        }

        return formClone;
    }

    const handleSubmit = () => {
        tryCatch(() => {
            setLoadingSubmit(true);

            if (formQuestion?.esFormularioSecuencial && formQuestion.pregunta!.length < 2) {
                openNotification('error', 'Error', 'Si el formulario es (secuenial) debe tener al menos (2 preguntas)');
                setLoadingSubmit(false);
            } else {

                // BEFORE CHANGE
                const formReviewed = reviewQuestionFormBeforeSending(formQuestion!);
                //

                if (mode === 'Add') {
                    InsertForm(formReviewed)
                        .then((response) => {
                            openNotification('success', `Formulario agregado`, response.msg!);
                            setAddUpdateModal(false);

                            // reset Table
                            let result: IForm = response.data;
                            result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;

                            let dataListInternal = dataList;
                            dataListInternal.push(result);
                            setDataList([...dataListInternal]);
                            setFormQuestion(undefined);
                            //
                        })
                        .catch((response) => {
                            openNotification('error', 'Error', getError(response?.msg));
                        })
                        .finally(() => setLoadingSubmit(false));
                } else if (mode === 'Update') {
                    UpdateForm(formReviewed)
                        .then((response) => {
                            openNotification('success', `Formulario Modificado`, response.msg!);
                            setFormQuestion(response.data);
                            setAddUpdateModal(false);

                            // reset Table
                            let result: IForm = response.data;
                            result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;
                            let dataListInternal = dataList;

                            let index = dataList.findIndex(x => x.formularioID === result.formularioID);
                            dataListInternal[index] = result;
                            setDataList([...dataListInternal]);
                            //

                        })
                        .catch((response) => {
                            openNotification('error', 'Error', getError(response?.msg));
                        })
                        .finally(() => setLoadingSubmit(false));
                } else {
                    formQuestion!.formularioID = 0;
                    formReviewed?.pregunta?.forEach(item => {
                        item.preguntaID = 0;
                        item.respuestaOpcion.forEach(respuesta => {
                            respuesta.preguntaSiguienteID = null;
                        })
                    })
                    InsertForm(formReviewed)
                        .then((response) => {
                            openNotification('success', `Formulario copiado`, response.msg!);
                            setFormQuestion(response.data);
                            setAddUpdateModal(false);

                            //reset Table
                            let result: IForm = response.data;
                            result.departamentoNombre = listDepartment.find(det => det.departamentoGUID === result.departamentoGUID)!.nombre;

                            let dataListInternal = dataList;
                            dataListInternal.push(result);
                            setDataList([...dataListInternal]);
                            setFormQuestion(undefined);
                            //

                        })
                        .catch((response) => {
                            openNotification('error', 'Error', getError(response?.msg));
                        })
                        .finally(() => setLoadingSubmit(false))
                }
            }
        });

    }

    const sliceStep = () => {

        if (!!formQuestion?.visualizacionTipoNombre && (formQuestion.visualizacionTipoNombre !== VisualizacionFormulario.ListadoDetalle && formQuestion.visualizacionTipoNombre !== VisualizacionFormulario.Mapa)) {
            setSteps(ConstSteps.slice(0, 3));
        } else {
            setSteps([...ConstSteps]);
        }
    }


    // States
    const [steps, setSteps] = useState<Step[]>(ConstSteps);

    // Effects
    useEffect(() => {
        if (mode === 'Add') {
            setFormQuestion(getCopyOf(fakeFormQuestion));

        }
    }, [mode]);

    useEffect(() => {
        sliceStep();
    }, [, formQuestion?.visualizacionTipoNombre]);



    return (
        <ModalContainer style={{ height: '100vh' }}>
            <ContentStepper mode={mode} canSubmit={statusFormQuestion} loadingSubmit={loadingSubmit} steps={steps} canGoBack={canGoBack} canGoNext={canGoNext} method={handleSubmit} />
        </ModalContainer>
    );
}

export default AddUpdateFormulario;